/*@flow*/
import qs from "qs";
import $ from "jquery";
import getToken from "lib/getToken";
import deleteKeys from "lib/deleteKeys";

type FetchOptsT = {|
  method?: "GET" | "POST" | "DELETE",
  body?: any,
  query?: Object,
  headers?: { [key: string]: string },
  credentials?: string,
  cors?: string,
  token?: string,
  crossOrigin?: boolean,
  noCredentials?: boolean,
  omitHeader?: boolean,
|};

export default function fetchSmart(
  url: string | URL,
  options: ?FetchOptsT
): Promise<Response> {
  let opts = {
    method: "GET",
  };

  url = url instanceof URL ? url.toString() : url;

  if (/^http/.test(url) === false) {
    const { protocol, host } = window.location;
    url = [protocol, "//", host, url].filter(Boolean).join("");
  }

  let queryString;

  if (options) {
    let { method, body, ...rest } = options;

    let credentials = "same-origin";

    if ((options.query && method === "GET") || !method) {
      queryString = qs.stringify(options.query, {
        arrayFormat: "brackets",
      });
    }

    if (options.credentials === "include") {
      credentials = "include";
    }

    if (options.cors) {
      credentials = "include";
    }

    let csrf = { "X-CSRF-Token": getToken() };

    if (options.token) {
      csrf["X-CSRF-Token"] = options.token;
    }

    if (rest.crossOrigin) {
      csrf = {};
    }

    if (rest.noCredentials) {
      credentials = undefined;
    }

    let headers = rest.omitHeader
      ? undefined
      : {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...csrf,
        };

    if (body) {
      const ctype = rest.headers && rest.headers["Content-Type"];
      if (ctype === "application/json" || ctype === undefined) {
        body = JSON.stringify(body);
      } else if (
        typeof ctype === "string" &&
        ctype.match(/x-www-form-urlencoded/)
      ) {
        body = $.param(body);
      }
    }

    if (!method) {
      method = opts.method;
    }

    opts = {
      method,
      body,
      credentials,
      headers,
      ...rest,
    };
  }

  const isValueUndefined = (k) => opts[k] === undefined || opts[k] === null;
  opts = deleteKeys(opts, isValueUndefined);

  // TODO: test
  if (!/\?/.test(url) && queryString) {
    url = `${url}?${queryString}`;
  }

  return fetch(url, opts);
}
